import { Button, Progress } from 'antd'
import React from 'react'

function Header({formatMessage, questions = [], onReset = () => {}, answers = {}}) {
  if(questions.length < 2){
    return null;
  }


  const count = Object.keys(answers).filter(key => answers[key].isAnswer).length;


  return (
    <div className='QuestionViewHeader'>
      <Progress percent={100/questions.length * count} showInfo={false} />
      <div className='text-count'>{count}/{questions.length}</div>
      <Button onClick={onReset}>{formatMessage('btnResetQuestions')}</Button>
    </div>
  )
}

export default Header


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionView/components/Header/Header.jsx